import theme from '../../styles/theme/theme';

export default theme;
